import { loadTemplate } from 'core-components/helpers/lazyLoad'
import { isEmpty } from 'core-components/library/validation'

interface ISettings {
  required?: boolean
  needLoad?: boolean
}

const getPathData = (value: string) => value.split(':')

const checkPath = async (value: string): Promise<object | null> => {
  const [path] = getPathData(value)
  return loadTemplate(path)
}

const checkPathDependency = (value: string, data: object | null) => {
  const [, name] = getPathData(value)
  return !data || !data[name]
}

export const isPathString = async (value: string, settings: ISettings = {}): Promise<string> => {
  if (settings.required && !value) {
    return isEmpty(value)
  }
  let result = !!value.length && value.split(':').length !== 2
  let errorText = 'Wrong path structure. Value must contain path and property name: ${PATH}:${NAME}'

  if (!result && settings.needLoad && value) {
    const [path, name] = getPathData(value)

    try {
      const pathData = await checkPath(value)
      result = checkPathDependency(value, pathData)
      if (result) {
        errorText = `Wrong dependency name. We can't find ${name} in file ${path}`
      }
    } catch (er) {
      result = true
      errorText = `Wrong path. We can't load path ${path}. Check projectLoaders in your project`
    }
  }

  return Promise.resolve(result ? errorText : '')
}
